import React from 'react';

const Edit = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3312_3894"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3312_3894)">
        <path
          d="M4.41253 22.0366C3.8781 22.0366 3.42574 21.8515 3.05544 21.4812C2.68515 21.1109 2.5 20.6585 2.5 20.1241V5.96339C2.5 5.42896 2.68515 4.9766 3.05544 4.6063C3.42574 4.23601 3.8781 4.05086 4.41253 4.05086H13.5702L11.9833 5.63782H4.41253C4.33113 5.63782 4.25652 5.67173 4.18868 5.73954C4.12087 5.80738 4.08696 5.88199 4.08696 5.96339V20.1241C4.08696 20.2055 4.12087 20.2801 4.18868 20.3479C4.25652 20.4158 4.33113 20.4497 4.41253 20.4497H18.5732C18.6546 20.4497 18.7293 20.4158 18.7971 20.3479C18.8649 20.2801 18.8988 20.2055 18.8988 20.1241V12.4862L20.4858 10.8993V20.1241C20.4858 20.6585 20.3006 21.1109 19.9303 21.4812C19.56 21.8515 19.1077 22.0366 18.5732 22.0366H4.41253ZM8.84794 15.6887V12.057L18.4329 2.47202C18.597 2.30789 18.7774 2.18819 18.9741 2.11291C19.1708 2.03764 19.3708 2 19.5743 2C19.7818 2 19.9812 2.03764 20.1724 2.11291C20.3637 2.18819 20.538 2.3045 20.6953 2.46184L22.0239 3.78636C22.1772 3.95047 22.2949 4.13155 22.3769 4.32959C22.459 4.52761 22.5 4.72834 22.5 4.9318C22.5 5.13526 22.4651 5.33262 22.3952 5.52387C22.3254 5.7151 22.2084 5.89278 22.0443 6.05691L12.4288 15.6887H8.84794ZM10.4349 14.1017H11.7533L18.3475 7.50758L17.6883 6.84837L16.9823 6.16882L10.4349 12.7162V14.1017Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export default Edit;
